import React from "react";
import { useSelector } from "react-redux";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { ThemeType } from "../../../../../redux/constants";
import RegistrationFooter from "./RegistrationFooter";

const ConnectedRegistrationFooter = () => {
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.FOOTER, state),
    );
    const {
        regFooterSettings: {
            securityLabel = "Transaction is secure and encrypted.",
        },
    } = themeSettings;

    return <RegistrationFooter securityLabel={securityLabel} />;
};

export default ConnectedRegistrationFooter;
